import * as ActionTypes from '../constants/action_types'

import { DefaultComparisonsListState, comparisonsList } from './compareList_reducer'


// -----------------------------------------------------------------------------
// Reducer for lists of topics (entities and video channels)

export const DefaultCompareState = {
  list: { ...DefaultComparisonsListState },
  byId: {}
}

export const compare = (state = DefaultCompareState, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_COMPARISONS:
    case ActionTypes.REQUEST_COMPARISONS_FAILURE:
    case ActionTypes.RECEIVE_COMPARISONS:
    case ActionTypes.INVALIDATE_COMPARISONS:
      return {
        ...state,
        list: comparisonsList(state.list, action)
      }
  default:
    return state
  }
}
